import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ar from "../../language/Ar";
import en from "../../language/En";
import { API_PATH } from "../../api/apiPath";
import { postApi } from "../../api/axiosInstance";

function Login({ setUser }) {
  const { translations } = useSelector((state) => state.language);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/");
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await postApi(API_PATH.AUTH.LOGIN, {
        username: data.username,
        password: data.password,
      });

      if (res.status) {
        const permission = {
          username: data.username,
          role: 0,
          token: res.data.data?.access_token,
        };
        const token = {
          token: res.data.data?.access_token,
        };
        console.log("Role:", res.data.role);

        localStorage.setItem("user", JSON.stringify(permission));
        localStorage.setItem("token", JSON.stringify(token));
        console.log("Successfully saved to localStorage");
        toast.success(translations.toastify.login_success);
        setUser(permission);
        navigate("/");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error saving to localStorage:", error);
      toast.error(translations.toastify.invalid_message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-gray-800 rounded-xl p-6 shadow-lg">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-4"
          autoComplete="off"
        >
          <div className="text-center">
            <img
              src="/images/logo/logo.png"
              className="w-[80px] h-[80px] rounded-full mx-auto my-2"
              alt="logo"
            />
            <h2 className="text-white text-3xl font-bold mb-2">
              {translations.login.jeema}
            </h2>
            <p className="text-gray-400 text-lg">{translations.login.login}</p>
          </div>

          <div className="flex flex-col mx-3">
            <input
              type="text"
              placeholder={translations.login.email}
              className="w-full px-4 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-[#5A189A]"
              {...register("username", {
                required: translations.login.email_warning,
              })}
            />
            {errors.username && (
              <p className="text-red-400 text-sm mt-1">
                {errors.username.message}
              </p>
            )}
          </div>

          <div className="flex flex-col mx-3">
            <input
              type="password"
              placeholder={translations.login.password}
              className="w-full px-4 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-[#5A189A]"
              {...register("password", {
                required: true,
                validate: {
                  checkLength: (value) => value.length >= 6,
                },
              })}
            />
            {errors.password?.type === "required" && (
              <p className="text-red-400 text-sm mt-1">
                {translations.login.password_warning}
              </p>
            )}
            {errors.password?.type === "checkLength" && (
              <p className="text-red-400 text-sm mt-1">
                Password should be at least 6 characters.
              </p>
            )}
          </div>

          <div className="text-center py-2">
            <button
              type="submit"
              disabled={loading}
              className="w-25 py-2 px-4 bg-[#5A189A] hover:bg-[#3C096C] transition-colors duration-300 text-white rounded-md font-semibold flex justify-center items-center mx-auto"
            >
              {loading ? (
                <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                translations.login.login
              )}
            </button>
          </div>

          {/* <div className="text-center my-3 text-sm">
            <Link to="/forget" className="text-[#5A189A] hover:underline">
              {translations.login.forget_password}
            </Link>
          </div> */}
        </form>
      </div>
    </div>
  );
}

export default Login;
